import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Theme as Bootstrap4Theme } from "@rjsf/bootstrap-4";
import useRequest from "../../hook/use-request.hook";
import { withTheme } from "@rjsf/core";
import { RJSFSchema } from "@rjsf/utils";
import { templates } from "../../util/form-util";
import validator from "@rjsf/validator-ajv8";
import ImuWidget from "./imuWidget";
const FormWithBootstrap = withTheme(Bootstrap4Theme);
export default function SurveyFasceBari() {
  const formRef = useRef<any>(null);
  const [historyCalc, setHistoryCalc] = useState<any[]>([]);
  const [userValue, setUserValue] = useState<any>(null);

  useEffect(() => {
    setModal(true);
  }, []);

  const FEATURE_DESCRIPTIONS: Record<string, string> = {
    "Appartamenti dal 1° piano fuori terra":
      "Seleziona se l’alloggio è dal primo piano in su (esclusi piano terra e piani interrati).",
    "Ingresso alloggio da piazza o da mare":
      "Seleziona se l’ingresso dell’alloggio immette o affaccia su piazza o fronte mare.",
    "Balcone con vista su piazza o mare": "Seleziona se è presente balcone con vista diretta su piazza o fronte mare.",
    "Allacciamento gas metano": "Seleziona se l’unità è allacciata alla rete di gas metano con utenza attiva.",
    "Impianto di condizionamento": "Seleziona se è presente un impianto di climatizzazione fisso e funzionante.",
    "Secondo servizio igienico": "Seleziona se è presente un secondo bagno completo nell’unità.",
    "Spazi esterni ad uso esclusivo e/o condominiale":
      "Seleziona se presenti balconi, terrazze, cortili o aree esterne ad uso esclusivo o condominiale.",
    "Porta blindata": "Seleziona se la porta d’ingresso è blindata e installata correttamente.",
    "Cantina o soffitta o giardino privato o terrazza a livello":
      "Seleziona se è presente almeno una tra cantina, soffitta, giardino privato, terrazza a livello.",
    "Posto auto di pertinenza e/o condominiale assegnato":
      "Seleziona se è disponibile posto auto di pertinenza o condominiale assegnato.",
    "Box auto": "Seleziona se è presente box auto di pertinenza dell’unità.",
    Ascensore: "Seleziona se l’ascensore è presente e funzionante nello stabile.",
    Portierato: "Seleziona se lo stabile dispone di servizio di portierato attivo.",
    "Videosorveglianza condominiale o individuale":
      "Seleziona se è presente videosorveglianza condominiale o privata funzionante.",
    "Impianto fotovoltaico o pannelli solari produzione acqua calda":
      "Seleziona se presenti fotovoltaico o solare termico per energia o acqua calda sanitaria.",
    "Impianto citofono": "Seleziona se l’unità dispone di citofono funzionante.",
    "Impianto di videocitofono": "Seleziona se l’unità dispone di videocitofono funzionante.",
    "Impianto di autoclave": "Seleziona se l’edificio è servito da autoclave in esercizio.",
    "Impianto elettrico interno adeguato ai sensi del D.M. 37/2008":
      "Seleziona se l’impianto elettrico è conforme e certificato ai sensi del D.M. 37/2008.",
    Attico: "Seleziona se l’unità è all’ultimo piano con caratteristiche tipiche di attico (es. terrazza a livello).",
    Ripostiglio: "Seleziona se è presente un ripostiglio interno all’unità.",
    Parquet: "Seleziona se i pavimenti dei principali ambienti sono in parquet.",
    "Postazione di ricarica veicoli elettrici nel box o nel posto auto in uso esclusivo o condominiale del conduttore o antenna satellitare":
      "Seleziona se presente ricarica EV nel box/posto auto o antenna satellitare dedicata.",
    "Cucina abitabile di almeno 9 mq, con finestra": "Seleziona se la cucina è ≥ 9 mq ed è finestrata.",
    "Sistemi di sicurezza / allarme": "Seleziona se è installato un sistema di sicurezza/allarme funzionante.",
    "Sistemi di domotica in almeno il 50% dell’unità immobiliare":
      "Seleziona se sistemi domotici coprono ≥ 50% delle funzioni dell’unità.",
    "Riscaldamento autonomo o centralizzato o pompa di calore":
      "Seleziona se presente riscaldamento autonomo, centralizzato o pompa di calore funzionante.",
    "Infissi interni ed esterni in buono stato":
      "Seleziona se gli infissi interni ed esterni risultano complessivamente in buono stato.",
    Cassaforte: "Seleziona se è presente cassaforte fissa integrata nell’unità.",
    "Doppio ingresso o cortile/giardino recintato":
      "Seleziona se l’unità ha doppio ingresso oppure cortile/giardino recintato.",
  };

  const FeatureCheckboxesWidget = ({ options, value, onChange, disabled, readonly }: any) => {
    const handleChange = (optionValue: string) => {
      const newValue = value.includes(optionValue)
        ? value.filter((v: string) => v !== optionValue)
        : [...value, optionValue];
      onChange(newValue);
    };

    return (
      <div>
        {options.enumOptions.map((option: any) => {
          const checked = value.includes(option.value);
          const description = FEATURE_DESCRIPTIONS[option.label] || "";

          return (
            <div key={option.value} style={{ marginBottom: "12px" }}>
              <label style={{ display: "block", fontWeight: 500 }}>
                <input
                  type="checkbox"
                  checked={checked}
                  disabled={disabled || readonly}
                  onChange={() => handleChange(option.value)}
                  style={{ marginRight: "8px" }}
                />
                {option.label}
              </label>
              {description && <div style={{ fontSize: "12px", color: "grey", marginLeft: "24px" }}>{description}</div>}
            </div>
          );
        })}
      </div>
    );
  };
  const schema: any = {
    title: "Questionario canone concordato Bari: calcola la fascia di locazione",
    description: "",
    //"Versione standalone (dati €/mq incorporati). Regole complete: fasce per zona, ammobiliato, “zona di pregio”.",
    type: "object",
    properties: {
      datiBase: {
        title: "Dati di Base",
        type: "object",
        properties: {
          zone: {
            title: "Zona (quartiere/area)",
            type: "string",
            enum: ["Z1", "Z2", "Z3", "Z4", "Z5", "Z6", "Z7", "Z8", "Z9", "Z10", "Z11", "Z12", "Z13"],
            enumNames: [
              "Zona 1 – Città Vecchia",
              "Zona 2 – Murat",
              "Zona 3 – Libertà",
              "Zona 4 – Madonnella",
              "Zona 5 – Japigia e Sant’Anna",
              "Zona 6 – San Paolo",
              "Zona 7 – Stanic",
              "Zona 8 – San Girolamo / Fesca",
              "Zona 9 – Torre a Mare / San Giorgio",
              "Zona 10 – Carrassi / San Pasquale",
              "Zona 11 – Poggiofranco/ Picone",
              "Zona 12 – Carbonara / Ceglie / Loseto",
              "Zona 13 – Santo Spirito / Palese",
            ],
          },
          arredo: {
            title: "Arredo",
            type: "string",
            enum: ["none", "partial", "full"],
            enumNames: ["Non Arredato", "Parzialmente Arredato", "Totalmente Arredato"],
          },
          mq: {
            title: "Superficie (mq)",
            type: "integer",
            minimum: 1,
          },
          // pregio: {
          //   type: "boolean",
          //   title: "Zona di pregio (ingresso/balcone su Sparano, C.so V.E., C.so Cavour, P.zza Garibaldi/Moro/Umberto)",
          // },
          // pianoOver2: {
          //   type: "boolean",
          //   title: "Piano oltre il 2°",
          // },
          // execFlag: {
          //   type: "boolean",
          //   title: "Immobile in zona Executive o Contrada Barone",
          // },
        },
        required: ["zone", "arredo", "mq"],
      },

      caratteristiche: {
        title: "Caratteristiche dell'immobile",
        type: "object",
        properties: {
          features: {
            type: "array",
            items: {
              type: "string",
              enum: [
                "Appartamenti dal 1° piano fuori terra",
                "Ingresso alloggio da piazza o da mare",
                "Balcone con vista su piazza o mare",
                "Allacciamento gas metano",
                "Impianto di condizionamento",
                "Secondo servizio igienico",
                "Spazi esterni ad uso esclusivo e/o condominiale",
                "Porta blindata",
                "Cantina o soffitta o giardino privato o terrazza a livello",
                "Posto auto di pertinenza e/o condominiale assegnato",
                "Box auto",
                "Ascensore",
                "Portierato",
                "Videosorveglianza condominiale o individuale",
                "Impianto fotovoltaico o pannelli solari produzione acqua calda",
                "Impianto citofono",
                "Impianto di videocitofono",
                "Impianto di autoclave",
                "Impianto elettrico interno adeguato ai sensi del D.M. 37/2008",
                "Attico",
                "Ripostiglio",
                "Parquet",
                "Postazione di ricarica veicoli elettrici nel box o nel posto auto in uso esclusivo o condominiale del conduttore o antenna satellitare",
                "Cucina abitabile di almeno 9 mq, con finestra",
                "Sistemi di sicurezza / allarme",
                "Sistemi di domotica in almeno il 50% dell’unità immobiliare",
                "Riscaldamento autonomo o centralizzato o pompa di calore",
                "Infissi interni ed esterni in buono stato",
                "Cassaforte",
                "Doppio ingresso o cortile/giardino recintato",
              ],
            },
            uniqueItems: true,
          },
        },
      },
    },
  };

  const uiSchema = {
    datiBase: {
      zone: {
        "ui:help": "Seleziona la zona/quartiere dell’immobile che vuoi affittare o cercare in affitto",
      },
      arredo: {
        "ui:help":
          "Seleziona: Non arredato; Parzialmente se solo alcune dotazioni minime; Totalmente se presenti: cucina completa, camera con letto+armadio, soggiorno con tavolo+sedie, bagno con specchio.",
      },
      mq: {
        "ui:help":
          "Inserisci la superficie utile interna in metri quadrati come numero intero; non la catastale; escludi pertinenze (es. 85).",
      },
      pregio: {
        "ui:help": "Seleziona se l’ingresso dell’alloggio o il balcone è su zone di pregio indicate.",
      },
      pianoOver2: {
        "ui:help": "Seleziona se l’alloggio si trova oltre il secondo piano.",
      },
      execFlag: {
        "ui:help": "Seleziona se l’immobile è in zona Executive o Contrada Barone.",
      },
      "ui:accent-color": "red",
    },
    caratteristiche: {
      features: {
        "ui:widget": FeatureCheckboxesWidget,
        "ui:title": " ",
      },
    },
  };

  const [dynamicSchema, setDynamicSchema] = useState(schema);
  const [modal, setModal] = useState(false);
  const [formDatas, setFormDatas] = useState({
    datiBase: { zone: "", arredo: "", mq: null, pregio: false, pianoOver2: false, execFlag: false },
    caratteristiche: {
      features: [],
    },
  });
  const [calcState, setCalcState] = useState({
    caratteristiche: [],
    mq: 0,
    arredo: "none",
    pregio: false,
    pianoOver2: false,
    execFlag: false,
    fascia: "",
    minPrice: 0,
    maxPrice: 0,
    summary: "",
  });

  function updateSpecialRules(zone: string, prevData: any) {
    let newSchema = { ...schema };
    let newFormData = { ...prevData };

    newFormData.datiBase = {
      ...newFormData.datiBase,
      pregio: false,
      pianoOver2: false,
      execFlag: false,
    };

    if (zone === "Z1" || zone === "Z3") {
      newSchema.properties.datiBase.properties.pregio = {
        type: "boolean",
        title: "Zona di pregio (balcone su mare/P. Mercantile/Ferrarese/Massari/Via Venezia)",
      };
      delete newSchema.properties.datiBase.properties.pianoOver2;
      delete newSchema.properties.datiBase.properties.execFlag;
    } else if (zone === "Z2") {
      newSchema.properties.datiBase.properties.pregio = {
        type: "boolean",
        title: "Zona di pregio (ingresso/balcone su Sparano, C.so V.E., C.so Cavour, P.zza Garibaldi/Moro/Umberto)",
      };
      newSchema.properties.datiBase.properties.pianoOver2 = {
        type: "boolean",
        title: "Piano oltre il 2°",
      };
      delete newSchema.properties.datiBase.properties.execFlag;
    } else if (zone === "Z10") {
      newSchema.properties.datiBase.properties.execFlag = {
        type: "boolean",
        title: "Immobile in zona Executive o Contrada Barone",
      };
      delete newSchema.properties.datiBase.properties.pregio;
      delete newSchema.properties.datiBase.properties.pianoOver2;
    } else {
      delete newSchema.properties.datiBase.properties.pregio;
      delete newSchema.properties.datiBase.properties.pianoOver2;
      delete newSchema.properties.datiBase.properties.execFlag;
    }

    setDynamicSchema(newSchema);
    setFormDatas(newFormData);
  }

  type Tier = "A" | "B" | "C" | "D";

  type PriceRange = { min: number; max: number };
  type ZonePrices = Partial<Record<Tier, PriceRange>>;
  type Prices = Record<`Z${1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13}`, ZonePrices>;

  const PRICES: Prices = {
    Z1: { A: { min: 5.26, max: 6.37 }, B: { min: 4.38, max: 5.25 }, C: { min: 2.18, max: 4.37 } },
    Z2: {
      A: { min: 6.63, max: 8.2 },
      B: { min: 5.38, max: 6.62 },
      C: { min: 4.76, max: 5.37 },
      D: { min: 2.37, max: 4.75 },
    },
    Z3: { A: { min: 5.13, max: 6.06 }, B: { min: 4.51, max: 5.12 }, C: { min: 4.11, max: 4.5 }, D: { min: 3.88, max: 4.1 } },
    Z4: { A: { min: 6.01, max: 6.5 }, B: { min: 5.31, max: 6.0 }, C: { min: 4.41, max: 5.3 }, D: { min: 3.41, max: 4.4 } },
    Z5: { A: { min: 5.26, max: 6.0 }, B: { min: 4.81, max: 5.25 }, C: { min: 3.51, max: 4.8 }, D: { min: 3.0, max: 3.5 } },
    Z6: {
      A: { min: 4.94, max: 5.18 },
      B: { min: 4.47, max: 4.93 },
      C: { min: 4.23, max: 4.56 },
      D: { min: 2.16, max: 4.31 },
    },
    Z7: { A: { min: 5.19, max: 5.5 }, B: { min: 4.91, max: 5.18 }, C: { min: 4.31, max: 4.9 }, D: { min: 2.16, max: 4.3 } },
    Z8: { A: { min: 5.13, max: 6.0 }, B: { min: 4.51, max: 5.12 }, C: { min: 3.88, max: 4.5 }, D: { min: 1.93, max: 3.78 } },
    Z9: { A: { min: 5.51, max: 5.9 }, B: { min: 4.71, max: 5.5 }, C: { min: 3.7, max: 4.7 } },
    Z10: { A: { min: 7.01, max: 7.5 }, B: { min: 6.01, max: 7.0 }, C: { min: 5.5, max: 6.0 } },
    Z11: { A: { min: 6.88, max: 7.5 }, B: { min: 6.26, max: 6.87 }, C: { min: 5.61, max: 6.25 }, D: { min: 5.0, max: 5.6 } },
    Z12: {
      A: { min: 5.26, max: 5.7 },
      B: { min: 4.88, max: 5.25 },
      C: { min: 4.13, max: 4.87 },
      D: { min: 2.06, max: 4.12 },
    },
    Z13: { A: { min: 5.69, max: 6.12 }, B: { min: 5.13, max: 5.68 }, C: { min: 2.56, max: 5.12 } },
  };

  // const IDX_RISC = FEATURES.indexOf("Riscaldamento autonomo o centralizzato o pompa di calore");
  // const IDX_AUTO = FEATURES.indexOf("Impianto di autoclave");
  // const IDX_INF = FEATURES.indexOf("Infissi interni ed esterni in buono stato");
  // const IDX_ASC = FEATURES.indexOf("Ascensore");

  const ZONES = [
    { id: "Z1", name: "Zona 1 – Città Vecchia", bands: 3 },
    { id: "Z2", name: "Zona 2 – Murat", bands: 4 },
    { id: "Z3", name: "Zona 3 – Libertà", bands: 4 },
    { id: "Z4", name: "Zona 4 – Madonnella", bands: 4 },
    { id: "Z5", name: "Zona 5 – Japigia e Sant’Anna", bands: 4 },
    { id: "Z6", name: "Zona 6 – Carrassi e San Pasquale", bands: 4 },
    { id: "Z7", name: "Zona 7 – Poggiofranco", bands: 4 },
    { id: "Z8", name: "Zona 8 – Picone", bands: 4 },
    { id: "Z9", name: "Zona 9 – San Paolo", bands: 3 },
    { id: "Z10", name: "Zona 10 – Carrassi / San Pasquale", bands: 3 },
    { id: "Z11", name: "Zona 11 – San Girolamo / Fesca / Marconi / San Cataldo", bands: 4 },
    { id: "Z12", name: "Zona 12 – Palese / Santo Spirito / Carbonara / Ceglie / Loseto", bands: 4 },
    { id: "Z13", name: "Zona 13", bands: 3 },
  ];

  const ARREDO_OPTIONS = [
    { id: "none", name: "Non Arredato" },
    { id: "partial", name: "Parzialmente Arredato" },
    { id: "full", name: "Totalmente Arredato" },
  ];

  function fasciaBase(zone: any, n: number) {
    if (zone.bands === 4) {
      if (n >= 8) return "A";
      if (n >= 6) return "B";
      if (n >= 4) return "C";
      return "D";
    } else {
      if (n >= 6) return "A";
      if (n >= 4) return "B";
      return "C";
    }
  }
  const onFormChange = ({ formData }: any) => {
    if (!formRef.current) return;

    const { datiBase, caratteristiche } = formData;

    const zona = datiBase?.zone;

    if (formDatas.datiBase.zone !== zona) {
      updateSpecialRules(zona, formData);
    }
    const PRESTIGE_FEATURES_Z1 = [
      "Impianto di autoclave",
      "Riscaldamento autonomo o centralizzato o pompa di calore",
      "Infissi interni ed esterni in buono stato",
    ];
    const zone = ZONES.find((z) => z.id === datiBase.zone) || ZONES[0];
    if ((zona === "Z1" || zona === "Z2" || zona === "Z3") && datiBase.pregio) {
      const currentFeatures = caratteristiche?.features || [];
      const newFeatures = Array.from(
        new Set([...currentFeatures, ...PRESTIGE_FEATURES_Z1]) // evita duplicati
      );

      formData = {
        ...formData,
        caratteristiche: {
          ...formData.caratteristiche,
          features: newFeatures,
        },
      };
    }
    const n = caratteristiche.features.length;

    let base = fasciaBase(zone, n);
    if (datiBase.zone === "Z1" && datiBase.pregio) base = "A";
    if (datiBase.zone === "Z2" && datiBase.pregio && datiBase.pianoOver2) base = "A";
    if (datiBase.zone === "Z10" && datiBase.execFlag) base = "A";

    const { fascia, coeff } = applyAmmobiliato(base, caratteristiche.features, datiBase.arredo);

    const mq = Number(datiBase.mq);
    type ZoneId = keyof typeof PRICES;
    type Tier = "A" | "B" | "C" | "D";
    const zoneId: ZoneId = zone.id as ZoneId;
    const tier: Tier = fascia as Tier;

    const priceRange = PRICES[zoneId][tier];
    let info = [`Zona: ${zone.name}`, `Elementi selezionati: ${n}`];
    let min = 0;
    let max = 0;
    if (priceRange) {
      const p = priceRange;
      if (mq > 0) {
        min = mq * p.min * (1 + coeff);
        max = mq * p.max * (1 + coeff);
        info.push(`Range canone stimato: € ${min.toFixed(2)} – € ${max.toFixed(2)}`);
      } else {
        info.push(`Range €/mq fascia ${fascia}: € ${p.min.toFixed(2)} – € ${p.max.toFixed(2)}`);
      }
    } else {
      info.push("Tariffe €/mq non disponibili per questa zona/fascia.");
    }

    if (datiBase.arredo !== "none") info.push("Arredo considerato nel calcolo");
    if (datiBase.zone === "Z2" && datiBase.pregio)
      info.push(
        datiBase.pianoOver2
          ? "Pregio Z2 attivo (ascensore >2° incluso)"
          : 'Pregio Z2: seleziona "Piano oltre il 2°" per attivare'
      );
    if (datiBase.zone === "Z1" && datiBase.pregio) info.push("Pregio Z1 attivo");
    if (datiBase.zone === "Z10" && datiBase.execFlag) info.push("Z10 Executive/Contrada Barone attivo");

    // summary.textContent = info.join(' • ');
    // console.log(min, max);
    setFormDatas(formData);
    setCalcState({
      caratteristiche: caratteristiche.features || [],
      mq: formData.datiBase.mq,
      arredo: formData.datiBase.arredo,
      pregio: datiBase.pregio,
      pianoOver2: datiBase.pianoOver2,
      execFlag: datiBase.execFlag,
      fascia,
      minPrice: priceRange ? min : 0,
      maxPrice: priceRange ? max : 0,
      summary: info.join(" • "),
    });
  };
  function applyAmmobiliato(fascia: string, selections: any[], arredo: string) {
    // controlliamo se l'array contiene gli elementi richiesti
    const hasRequisiti =
      selections.includes("Riscaldamento autonomo o centralizzato o pompa di calore") &&
      selections.includes("Impianto di autoclave") &&
      selections.includes("Infissi interni ed esterni in buono stato");

    let coeff = 0;
    let fasciaFinale = fascia;

    if (arredo === "partial") {
      if (["B", "C", "D"].includes(fascia)) {
        if (hasRequisiti) {
          fasciaFinale = "A";
          coeff = 0;
        }
      } else if (fascia === "A") {
        coeff = 0.1;
      }
    } else if (arredo === "full") {
      if (["B", "C", "D"].includes(fascia)) {
        if (hasRequisiti) {
          fasciaFinale = "A";
          coeff = 0.1;
        }
      } else if (fascia === "A") {
        coeff = 0.2;
      }
    }

    return { fascia: fasciaFinale, coeff };
  }

  function onFormSubmit({ formData }: any) {
    const zone = ZONES.find((z) => z.id === formDatas.datiBase.zone) || ZONES[0];
    const arr = ARREDO_OPTIONS.find((a) => a.id === formDatas.datiBase.arredo) || ARREDO_OPTIONS[0];
    const diff = userValue > 0 && calcState.minPrice > 0 ? userValue - calcState.minPrice : null;
    //setModal(true);
    setHistoryCalc((prev) => [
      ...prev,
      {
        zone: zone.name,
        elem: formDatas.caratteristiche.features.length,
        mq: formDatas.datiBase.mq,
        arredo: arr.name,
        pregio: formDatas.datiBase.pregio,
        pianoOver2: formDatas.datiBase.pianoOver2,
        execFlag: formDatas.datiBase.execFlag,
        fascia: calcState.fascia,
        minPrice: calcState.minPrice,
        maxPrice: calcState.maxPrice,
        summary: calcState.summary,
        imu: userValue,
        saving: diff,
      },
    ]);
  }
  const SubmitButtonTemplate = (props: any) => {
    return (
      <>
        <Button color="primary" type="submit">
          Calcola Fascia
        </Button>{" "}
        {/* <Button color="primary" onClick={handleClick}>
          Calcola IMU
        </Button>
        <Button color="primary ml-1" onClick={() => {}}>
          Calcolo sgravio IRPEF
        </Button> */}
      </>
    );
  };

  const DisclaimerModal = () => {
    const handleAccept = () => {
      //localStorage.setItem("disclaimerAccepted", "true");
      setModal(false);
    };

    return (
      <Modal isOpen={modal} backdrop="static" centered keyboard={false}>
        <ModalHeader className="text-danger">Attenzione</ModalHeader>
        <ModalBody>
          Si invita sempre alla verifica dei calcoli con l'ausilio di un professionista. <br /> <br />
          L’Agenzia Sociale per la casa non è responsabile di eventuali danni e/o perdite di profitti causati dall'uso di
          Canone Giusto che viene fornito gratuitamente cosi com'è. L'utente con l'utilizzo dell'applicazione solleva
          L’Agenzia Sociale per la casa da ogni responsabilità, implicita ed esplicita, derivante dall'uso dell'applicazione
          stessa.
          <br />
          <br />
          Attenzione, si rammenta che il calcolo è effettuato esclusivamente sui dati forniti dal contribuente. E' pertanto
          necessario che il contribuente controlli con cura tutti i dati degli immobili. <br />
          <br />
          L'Amministrazione comunale non si assume nessuna responsabilità circa l'inesattezza dei dati medesimi.
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleAccept}>
            Ho capito
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  const handleClick = () => {
    window.open(
      "https://cloud.ddmanagement.it/bari/admin/st800.php",
      "ddmanagement",
      "width=900,height=700,left=200,top=100,scrollbars=yes,resizable=yes"
    );
  };

  return (
    <Container>
      {" "}
      <DisclaimerModal />
      <div className="my-form-survey">
        <FormWithBootstrap
          ref={formRef}
          formData={formDatas}
          onSubmit={onFormSubmit}
          onChange={onFormChange}
          schema={dynamicSchema}
          uiSchema={uiSchema}
          templates={{
            ...templates, // mantieni gli altri template
            ButtonTemplates: {
              SubmitButton: SubmitButtonTemplate,
            },
          }}
          validator={validator}
        ></FormWithBootstrap>{" "}
        <div style={{ marginTop: "16px" }}>
          <div style={{ marginTop: "20px" }}>
            <label htmlFor="externalValue">
              <strong>Inserisci IMU :</strong>
            </label>
            <input
              type="number"
              id="externalValue"
              placeholder="0"
              step="0.01"
              min={0}
              onChange={(e) => {
                const val = parseFloat(e.target.value);
                if (isNaN(val)) setUserValue(null);
                else setUserValue(val);
              }}
              style={{ marginLeft: "10px", padding: "4px" }}
            />
          </div>
          <strong style={{ fontSize: "25px" }}>Esito in Tempo Reale</strong> <br />
          <strong>Fascia:</strong> {calcState.fascia || "—"} <br />
          <strong>Range prezzo:</strong> € {calcState.minPrice.toFixed(2)} – € {calcState.maxPrice.toFixed(2)} <br />
          <em>{calcState.summary}</em>
        </div>
        {historyCalc.map((sim, index) => (
          <div
            key={index}
            style={{
              marginTop: "12px",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "8px",
            }}
          >
            <strong>Zona:</strong> {sim.zone} <br />
            <strong>Fascia:</strong> {sim.fascia} <br />
            <strong>Elementi selezionati:</strong> {sim.elem} <br />
            <strong>Arredo:</strong> {sim.arredo} <br />
            <strong>Superficie (mq):</strong> {sim.mq} <br />
            <strong>Range prezzo:</strong> € {sim.minPrice.toFixed(2)} – € {sim.maxPrice.toFixed(2)} <br />
            <em>{sim.summary}</em> <br />
            {sim.imu && sim.saving > 0 && <strong>IMU inserito: € {sim.imu.toFixed(2)}</strong>}
            {sim.saving > 0 && (
              <>
                {" "}
                <br />
                <div
                  style={{
                    marginTop: "10px",
                    padding: "8px",
                    border: "2px solid #b22222",
                    borderRadius: "8px",
                    backgroundColor: "#fff5f5",
                    textAlign: "center",
                  }}
                >
                  <strong>
                    Se affitti il tuo immobile tramite Agenzia sociale per la casa risparmierai € {sim.saving.toFixed(2)}
                  </strong>
                </div>
              </>
            )}
          </div>
        ))}{" "}
        <p className="mt-3">
          Per maggiori informazioni sul meccanismo di calcolo utilizzato consultare l'
          <a
            href="/ACCORDO-TERRITORIALE-BARI-2024.pdf"
            download="ACCORDO-TERRITORIALE-BARI-2024.pdf"
            className="text-blue-600 font-semibold hover:underline"
          >
            ACCORDO TERRITORIALE DEL COMUNE DI BARI - 13/03/2024
          </a>
        </p>
        <div className="mt-2" style={{ fontSize: "14px", color: "#333333", marginLeft: "15px" }}>
          <strong>
            {" "}
            Si invita sempre alla verifica dei calcoli con l'ausilio di un professionista. <br /> <br />
            L’Agenzia Sociale per la casa non è responsabile di eventuali danni e/o perdite di profitti causati dall'uso di
            Canone Giusto che viene fornito gratuitamente cosi com'è. L'utente con l'utilizzo dell'applicazione solleva
            L’Agenzia Sociale per la casa da ogni responsabilità, implicita ed esplicita, derivante dall'uso
            dell'applicazione stessa.
            <br />
            <br />
            Attenzione, si rammenta che il calcolo è effettuato esclusivamente sui dati forniti dal contribuente. E' pertanto
            necessario che il contribuente controlli con cura tutti i dati degli immobili. <br />
            <br />
            L'Amministrazione comunale non si assume nessuna responsabilità circa l'inesattezza dei dati medesimi.
          </strong>
        </div>
        <div>
          {" "}
          <Button color="primary mt-5" onClick={handleClick}>
            Calcola IMU
          </Button>
          <div className="mt-2" style={{ fontSize: "14px", color: "grey" }}>
            Clicca su “Calcola IMU”: si aprirà la pagina esterna del Comune di Bari. <br />
            Esegui il calcolo e prendi l’importo totale dovuto (annuale, come mostrato). <br />
            Torna qui e inserisci l’importo nel campo “Quanto paghi oggi di IMU (annuale)?” in euro, senza il simbolo € e
            senza punti/spazi per le migliaia.
            <br /> Usa due decimali (es. 1234,56; se il campo non accetta la virgola, usa 1234.56).
          </div>
          <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-start", width: "100%" }}>
            {" "}
            <ImuWidget />
          </div>
          <p className="mt-3">
            ⚠️ Appartamento sfitto con utenze attive: paghi la TARI come la tua prima casa (utenza principale) - stessi
            occupanti finché resta sfitto <br />
            <a
              href="https://www.comune.bari.it/documents/20181/430013/2025-DCC-29-2025-Regolamento-TARI.pdf/781a2d2c-eef0-4a3b-9c34-64e6bbd145ae"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 font-semibold hover:underline"
            >
              (Art. 13 TARI Bari 2025)
            </a>
          </p>
        </div>
      </div>
    </Container>
  );
}
